<!-- <table class="table table-bordered" id="table" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ circulationStatusI18n?.nameI18n }}</th>
      <th></th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ circulationStatusI18n?.nameI18n }}</th>
      <th></th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let t of circulationStatus">
      <td>{{ t.name }}</td>
      <td>
        <button
          type="button"
          data-toggle="modal"
          (click)="edit(t.id)"
          data-target="#edit"
          class="btn btn-warning btn-sm"
        >
          <i class="fas fa-edit"></i>
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          (click)="delete(t.id)"
        >
          <i class="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table> -->

<ngx-datatable
class="bootstrap"
[rows]="circulationStatus"
[columnMode]="'force'"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[loadingIndicator]="loadingIndicator"
[reorderable]="reorderable"
>
<ngx-datatable-column name="ID" prop="id"></ngx-datatable-column>
<ngx-datatable-column name="Name" prop="name"></ngx-datatable-column>
<ngx-datatable-column name="Actions">
  <ng-template ngx-datatable-cell-template let-row="row">
    <!-- <button class="btn btn-sm btn-outline-primary" (click)="openEditDialog(row)">Edit</button>
    <button class="btn btn-sm btn-outline-danger" (click)="delete(row)">Delete</button> -->
    <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Actions
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" (click)="openEditDialog(row)">
        <i class="fas fa-edit text-primary"></i> Edit
      </a>
      <a class="dropdown-item" (click)="delete(row.id)">
        <i class="fas fa-trash-alt text-danger"></i> Delete
      </a>
    </div>
  </ng-template>
</ngx-datatable-column>
</ngx-datatable>
